<template>
  <div class="shell">
    <div class="policy">
      <div class="policyTitle">
        <div v-if="endorseNo && encryptKey" class="title-name">
          电子批单
        </div>
        <div v-else class="title-name">
          电子保单/批单
        </div>
      </div>
      <!-- <div
          class="policyBody"
          v-if="ePolicyDtoList.length !== 0 && channelCode !== 'DP_WXMP'"
        >
          <p
            class="policy-clause"
            v-for="(item, i) in ePolicyDtoList"
            :key="i"
            @click="details(item,i)"
          >
            {{
              productCode === "motor_product" && item.compulsorySignFlag === "1"
                ? "保险标志"
                : item.downLoadName
            }}
            <wx-open-launch-weapp
              id="launch-btn"
              username="gh_a61d04a74613"
              :path="item.path"
              v-if="isAPP"
            >
              <script type="text/wxtag-template">
                <style>.wx_btn{
                      width:100%;
                      height:40px;
                      opacity:0;
                  }
                </style>
                  <button class="wx_btn">
                    查看电子保单
                  </button>
              </script>
            </wx-open-launch-weapp>
          </p>
        </div> -->
      <div
        v-if="ePolicyDtoList.length !== 0"
        class="policyBody"
      >
        <p
          v-for="(item, i) in ePolicyDtoList"
          :key="i"
          class="policy-clause"
          @click="details(item,i)"
        >
          {{
            item.compulsorySignFlag === "1"
              ? "保险标志"
              : item.riskName
          }}
          <wx-open-launch-weapp
            v-if="isAPP"
            id="launch-btn"
            username="gh_a61d04a74613"
            :path="'pages/pdf/pdf.html?pdfUrl=' + encodeURIComponent(item.downloadPath) + '&pdfName=' + encodeURIComponent(item.pdfName) + '&token=' + encodeURIComponent(token)"
          >
            <script type="text/wxtag-template">
              <style>.wx_btn{
              width:100%;
              height:40px;
              opacity:0;
              }
              </style>
              <button class="wx_btn">
              查看电子保单
              </button>
            </script>
          </wx-open-launch-weapp>
        </p>
      </div>
      <div v-if="policyTitle" class="policyBody">
        <p class="policy-clause">
          暂无订单
        </p>
      </div>
    </div>
    <van-popup v-model="cardShow" class="vantPop" :close-on-click-overlay="false">
      <div class="popTop">请输入证件号后6位</div>
      <van-field
        v-model="identifyNo"
        placeholder="请输入证件号后6位"
        maxlength="6"
      />
      <div class="popBtn" @click="elePolicyDownLoadValidIdentity">
        确认
      </div>
    </van-popup>
    <Loading :switchs="switchs" />
  </div>
</template>

<script>
import api from '@/api/api.js'
import pdfPreview from './mixin/pdfPreview'
import checkFormat from '@/utils/checkFormat.js'
import Loading from '@/components/Loadings/Loading'
import { Toast } from 'vant'
export default {
  components: {
    'Loading': Loading
  },
  mixins: [pdfPreview],
  data() {
    return {
      switchs: false, // loading
      orderId: this.$route.query.orderId || '',
      orderNo: this.$route.query.orderNo || '',
      token: this.$route.query.token || '',
      channelCode: this.$route.query.channelCode || '',
      ePolicyDtoList: [], // pdf地址数据
      policyTitle: false,
      path: 'pages/pdf/pdf.html?pdfUrl=',
      isAPP: false,
      productCode: '',
      endorseNo: this.$route.query.endorseNo || '',
      encryptKey: this.$route.query.encryptKey || '',
      orderEncryptKey: this.$route.query.orderEncryptKey || '',
      cardShow: false, // 证件后6位弹框
      identifyNo: '' //  证件后6位参数
    }
  },
  created() {
    // this.getORderetails()
  },
  mounted: function() {
    // console.log(this.$route.query)
    if (this.encryptKey && this.endorseNo && (this.channelCode === 'DP_WXMP' || this.channelCode === 'DP_ZYB')) {
      this.getCarEndorsement()
    } else {
      // this.channelCode === "DP_WXMP"? this.getORderetails_ZSB() : this.getORderetails()
      this.orderEncryptKey ? this.getElePolicy() : this.getORderetails_ZSB()
    }
  },
  methods: {
    // / 车险移动端ios微信打开小程序
    // / 车险移动端安卓微信打开原生
    // / 车险PC端均打开原生
    // / 摩托车险移动端均打开小程序
    // / 摩托车险pc端均打开原生
    // / 非车险均打开原生
    getWeapp(code) {
      const environment = this.getIsWxClient()// 判断是否微信环境
      const mobileEnv = this.getIsMobileClient()// 判断是否手机环境
      const iosEnv = this.getIsIos()// 判断是否ios环境
      if (environment) {
        if (iosEnv && mobileEnv) {
          this.isAPP = true
        } else {
          code === 'motor_product' && mobileEnv
            ? (this.isAPP = true)
            : (this.isAPP = false)
        }
      } else {
        this.isAPP = false
      }
    },
    getElePolicy() {
      const headers = {
        headers: {
          Authorization: this.token
        }
      }
      const data = {
        orderDto: {
          businessNo: this.orderNo,
          encryptKey: this.orderEncryptKey
        },
        serviceName: this.channelCode
      }
      this.switchs = true
      this.$http.post(api.elePolicyBatchDownloadWithCheck, data, headers).then((res) => {
        this.switchs = false
        if (res.status === 401) { // 如果token失效，弹框输入证件后6位，掉新接口
          // alert('401')
          this.cardShow = true
        } else if (res.status === 200) {
          if (res.data.rtnCode === '0000') {
            this.getSuccess(res)
          } else {
            // Toast(res.data.rtnMsg)
            this.getORderetails_ZSB()
          }
        }
      }).catch(error => {
        this.switchs = false
        console.log(error)
      })
    },
    getSuccess(res) {
      if (res.data.elePolicyBatchDownloadInfoDto.elePolicyDownloadInfoDtoList && res.data.elePolicyBatchDownloadInfoDto.elePolicyDownloadInfoDtoList.length > 0) {
        res.data.elePolicyBatchDownloadInfoDto.elePolicyDownloadInfoDtoList.forEach(item => {
          if (item.riskCode === '0591' && item.compulsorySignFlag === '1') {
            this.productCode = 'motor_product'
            this.getWeapp(this.productCode)
          } else {
            this.productCode = 'CAR20190517'
            this.getWeapp(this.productCode)
          }
        })
        this.ePolicyDtoList = res.data.elePolicyBatchDownloadInfoDto.elePolicyDownloadInfoDtoList
        this.ePolicyDtoList.map((el) => {
          const pdfName = el.licenseNo ? el.licenseNo + '-' + el.policyNo + '.pdf' : el.policyNo + '.pdf'
          this.$set(
            el,
            'path',
            this.path + encodeURIComponent(el.downloadPath)
          )
          this.$set(
            el,
            'policyNo',
            el.policyNo
          )
          this.$set(
            el,
            'pdfName',
            pdfName
          )
        })
      }
    },
    elePolicyDownLoadValidIdentity() {
      if (!this.identifyNo) {
        Toast('请输入证件号后6位')
      } else {
        const headers = {
          headers: {
            Authorization: this.token
          }
        }
        const data = {
          identifyNo: this.identifyNo,
          orderDto: {
            businessNo: this.orderNo,
            encryptKey: this.orderEncryptKey
          },
          serviceName: this.channelCode
        }
        console.log(data, '0000999')
        this.switchs = true
        this.$http.post(api.elePolicyDownLoadValidIdentity, data, headers).then((res) => {
          this.switchs = false
          if (res.data.rtnCode === '0000') {
            this.getSuccess(res)
            this.cardShow = false
          } else {
            Toast(res.data.rtnMsg)
          }
        }).catch(err => {
          this.switchs = false
          console.log(err)
        })
      }
    },
    getORderetails_ZSB() {
      // 根据url传参的订单号和订单ID获取订单详情 '&fileContentFlag=0'是否返回文件流
      if (this.orderId && this.orderNo && this.token) {
        const headers = {
          headers: {
            Authorization: this.token
          }
        }
        const data = {
          fileContentFlag: '0',
          orderId: this.orderId
          // orderNo: this.orderNo
        }
        this.switchs = true
        this.$http.post(api.queryOrderDetail_ZSB, data, headers).then((res) => {
          this.switchs = false
          if (res.data.rtnCode === '0000') {
            if (res.data.data && res.data.data.oldDetail.resultObj.productCode) {
              this.productCode = res.data.data.oldDetail.resultObj.productCode
            }
          } else {
            Toast(res.data.rtnMsg)
          }
          this.getWeapp(this.productCode)
          // 获取的可以预览的pdf数据
          if (res.data.data.elePolicy && res.data.data.elePolicy.length) {
            this.ePolicyDtoList = res.data.data.elePolicy
            this.ePolicyDtoList.map((el) => {
              const pdfName = el.licenseNo ? el.licenseNo + '-' + el.policyNo + '.pdf' : el.policyNo + '.pdf'
              this.$set(
                el,
                'path',
                this.path + encodeURIComponent(el.downloadPath)
              )
              this.$set(
                el,
                'policyNo',
                el.policyNo
              )
              this.$set(
                el,
                'pdfName',
                pdfName
              )
            })
            console.log(this.ePolicyDtoList, 'this.ePolicyDtoList')
          } else {
            this.policyTitle = true
          }
        }).catch(error => {
          this.switchs = false
          console.log(error)
        })
      } else {
        this.policyTitle = true
      }
    },
    // getORderetails() {
    //   // 根据url传参的订单号和订单ID获取订单详情 '&fileContentFlag=0'是否返回文件流
    //   if (this.orderId) {
    //     this.$http
    //       .post(
    //         api.queryOrderDetail +
    //           "?orderId=" +
    //           this.orderId +
    //           "&fileContentFlag=0"
    //       )
    //       .then((res) => {
    //         if (res.data.resultObj && res.data.resultObj.productCode) {
    //           this.productCode = res.data.resultObj.productCode;
    //         }
    //         this.getWeapp(this.productCode);
    //         // 获取的可以预览的pdf数据
    //         if (
    //           res.data.resultObj.ePolicyDtoList &&
    //           res.data.resultObj.ePolicyDtoList.length
    //         ) {
    //           this.ePolicyDtoList = res.data.resultObj.ePolicyDtoList;
    //           this.ePolicyDtoList.map((el) => {
    //             this.$set(
    //               el,
    //               "path",
    //               this.path +
    //                 encodeURIComponent(
    //                   "https:" + api.projectHostUrl + el.downLoad
    //                 )
    //             );
    //           });
    //           console.log(this.ePolicyDtoList,'this.ePolicyDtoList');
    //         } else {
    //           this.policyTitle = true;
    //         }
    //       });
    //   } else {
    //     this.policyTitle = true;
    //   }
    // },
    // 紫属保/紫易保车险批单
    getCarEndorsement() {
      if (this.endorseNo && this.encryptKey && this.token) {
        const data = {
          endorseNo: this.endorseNo,
          encryptKey: this.encryptKey
        }
        const headers = {
          headers: {
            Authorization: this.token
          }
        }
        this.switchs = true
        this.$http.post(api.queryCarEndorseDetail, data, headers).then((res) => {
          this.switchs = false
          this.getWeapp(this.productCode)
          // 获取可以预览的pdf数据
          if (res.data.data && res.data.data.queryEndorseInfoDetailRespVO.riskName && res.data.data.eleEndorseDownloadDto && res.data.data.eleEndorseDownloadDto.downloadPath) {
            this.ePolicyDtoList = []
            this.ePolicyDtoList.push(res.data.data.eleEndorseDownloadDto)
            console.log(this.ePolicyDtoList, '=0900--00000000')
            this.ePolicyDtoList.forEach((el) => {
              const pdfName = el.licenseNo ? el.licenseNo + '-' + el.policyNo + '.pdf' : el.policyNo + '.pdf'
              this.$set(
                el,
                'path',
                this.path + encodeURIComponent(el.downloadPath)
              )
              this.$set(
                el,
                'riskName',
                res.data.data.queryEndorseInfoDetailRespVO.riskName
              )
              this.$set(
                el,
                'policyNo',
                res.data.data.queryEndorseInfoDetailRespVO.policyNo
              )
              this.$set(
                el,
                'pdfName',
                pdfName
              )
            })
          } else {
            this.policyTitle = true
          }
        }).catch(err => {
          this.switchs = false
          console.log(err)
        })
      } else {
        this.policyTitle = true
      }
    },
    details(item, index) {
      console.log(item, '===----')
      const obj = {
        orderId: this.orderId,
        orderNo: this.orderNo,
        token: this.token,
        index: index,
        encryptKey: this.encryptKey,
        endorseNo: this.endorseNo,
        channelCode: this.channelCode,
        orderEncryptKey: this.orderEncryptKey,
        policyNo: item.policyNo
      }
      if (!this.isAPP) {
        if (checkFormat.checkEnv() === 'APP') {
          previewPDF.postMessage(api.projectHostUrl + item.downLoad)
        } else {
          if (item.downloadPath) {
            window.open(item.downloadPath)
          } else {
            this.$router.push({ name: 'imgCon', params: { obj: obj }})
          }
        }
        // else if (this.channelCode === "DP_WXMP") {
        //   // window.open(item.downloadPath);
        //   obj.channelCode = "DP_WXMP"
        //   if (item.downloadPath) {
        //     window.open(item.downloadPath);
        //   } else {
        //     this.$router.push({name:'imgCon',params:{obj:obj}})
        //   }
        // } else if (this.channelCode !== "DP_WXMP") {
        //   obj.channelCode = "DP_ZYB"
        //   if (this.channelCode === "DP_ZYB" && this.encryptKey && this.endorseNo){
        //     if (item.downloadPath) {
        //       window.open(item.downloadPath)
        //     } else {
        //       this.$router.push({name:'imgCon',params:{obj:obj}})
        //     }
        //   } else {
        //     if (item.downLoad){
        //       window.open(api.projectHostUrl + item.downLoad)
        //     } else {
        //       this.$router.push({name:'imgCon',params:{obj:obj}})
        //     }
        //   }

        // }
      }
    },
    // 判断是否微信环境
    getIsWxClient() {
      const ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i).length > 0 && ua.match(/MicroMessenger/i) == 'micromessenger') {
        console.log('微信环境')
        return true
      }
      return false
    },
    // 判断是否手机环境
    getIsMobileClient() {
      const ua = navigator.userAgent.toLowerCase()
      if (/mobile/i.test(ua)) {
        console.log('手机环境')
        return true
      }
      return false
    },
    // 判断是否ios环境
    getIsIos() {
      const ua = navigator.userAgent.toLowerCase()
      const isIos = !!ua.match(/\(i[^;]+;( u;)? cpu.+mac os x/)
      return isIos
      // if (isIos) {
      //   console.log(isIos)
      //   return true
      // } else {
      //   return false
      // }
    }
  }
}
</script>

  <style lang="scss" scoped>
  #launch-btn {
    width: 100%;
    height: 0.4rem;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  [v-cloak] {
    display: none;
  }
  * {
    margin: 0;
    font-size: 0.14rem;
    padding: 0;
  }
  .vantPop{
    width: 80%;
    padding:.15rem;
    padding-top: .2rem;
    border-radius: .05rem;
    box-sizing: border-box;
    text-align: center;
    /deep/ .van-field__value{
      border: 1px solid #ccc;
      border-radius: .05rem;
      padding:.08rem;
      color: #333;
    }
    .popTop{
      font-size: .16rem;
      font-weight: 600;
      padding-bottom:.15rem;
    }
    .popBtn{
      width: 100%;
      height: .4rem;
      line-height: .4rem;
      background: rgba(101, 46, 143, 1);
      color: #fff;
      text-align: center;
      margin: .15rem 0;
      border-radius: .05rem;
    }
  }
  .shell {
    font-size: 0.14rem;
    padding: 0.1rem;
    background-color: #f7f6f9;
    .policy {
      overflow: hidden;
      padding: 0.2rem;
      background-color: #fff;
      border-radius: 0.1rem;
      .policyTitle {
        .title-name {
          height: 0.22rem;
          font-size: 0.16rem;
          line-height: 0.22rem;
          font-weight: 600;
          padding: 0.1rem 0;
          color: #333;
        }
      }
      .policyBody {
        .policy-clause {
          display: block;
          font-size: 0.14rem;
          line-height: 0.3rem;
          color: rgba(101, 46, 143, 1);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          position: relative;
          border-top: 2px solid #f7f6f9;
          padding: 0.14rem 0;
        }
      }
    }
  }
  </style>




// WEBPACK FOOTER //
// src/pages/Pdf/PdfDown/PdfDown.vue